<template>
  <div class="language-switcher-wrapper">
    <div class="language-switcher">
      <div class="selected-language">
        <span>{{ $i18n.locale === 'en' ? 'ENGLISH' : 'LATVISKI' }}</span>
        <img src="@/assets/img/lv-flag.svg" v-if="$i18n.locale === 'lv'">
        <img src="@/assets/img/uk-flag.svg" v-if="$i18n.locale === 'en'">
      </div>
      <div class="language-options">
        <button type="button"
          v-if="$i18n.locale !== 'en'"
          class="language-option" 
          @click="changeLanguage('en')"
        >
          <span>ENGLISH</span>
          <img src="@/assets/img/uk-flag.svg">
        </button>
        <button type="button"
          v-if="$i18n.locale !== 'lv'"
          class="language-option" 
          @click="changeLanguage('lv')"
        >
          <span>LATVISKI</span>
          <img src="@/assets/img/lv-flag.svg">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  methods: {
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('language', locale);
    }
  }
};
</script>

<style scoped>
.language-switcher-wrapper {
  display: flex;
}
.language-switcher {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.selected-language {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  padding: 4px 12px;
  transition: 0.2s ease;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.selected-language img {
  margin-left: 15px;
  height: 40px;
}
.selected-language span {
  align-self: center;
  font-size: 22px;
  font-weight: 600;
}
.language-options {
  position: absolute;
  top: 48px;
  background-color: var(--bg-navbar-color);
  display: flex;
  align-items: flex-end;
  width: 100%;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.language-switcher:hover .selected-language {
  background-color: var(--bg-modal-content-color);
}
.language-switcher:hover .language-options {
  opacity: 1;
  visibility: visible;
}
.language-options .language-option {
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 4px 12px;
}
.language-options .language-option:hover {
  opacity: 0.8;
}
.language-options .language-option img {
  margin-left: 15px;
  height: 40px;
}
.language-options .language-option span {
  align-self: center;
  font-size: 16px;
  font-weight: 600;
}
</style>
